export class ContractModel {
  term: number;
  termType: string;


  // Default constructor will be called by mapper
  constructor() {
    this.term = undefined;
    this.termType = undefined;

  }

}
